import React from 'react';

interface btnProps {
  label: string;
  className?: string;
}
const btnClassName = 'h-[48px] items-center bg-cic-blue-500 w-fit text-base-white text-md leading-sm font-button font-semibold rounded-m hover:no-underline active:bg-[#0686C8] px-xl py-m';
export default function RedirectButton({ label, className }: btnProps) {
  const interestHref = `/talk-to-expert`;

  return (
    <a
      href={interestHref}
      className={`${className} ${btnClassName}`}>
      {label}
    </a>
  )
}
